import { OrganizationAuthMethodEnum } from 'src/api/main'
import { paths } from 'src/router'

import { SocialConnectCallbackPage } from './SocialConnectCallbackPage'

export const EntraIdConnectCallback = () => (
  <SocialConnectCallbackPage
    provider={OrganizationAuthMethodEnum.ENTRAID}
    flow="connect"
    redirectPath={paths.auth.entraIdConnectCallback}
    successMessageKey="profileAuthMethods.connectSuccessEntraid"
  />
)
